import React, { useMemo } from "react";
import styles from "./TopDonorsMobileShareModal.module.scss";
import { observer } from "mobx-react";
import { Modal } from "semantic-ui-react";
import { useStores } from "../../../hooks/mobx";
import { SHARE_LINKS } from "../../event/ui/EventMainInfo/EventShareBlock";

const TopDonorsMobileShareModal: React.FC = observer(() => {
  const { topDonorPageStore } = useStores();
  const { userData, appliedFiltersCount } = topDonorPageStore;

  const onCloseModalClick = () => {
    topDonorPageStore.setShareOpenModal(false);
  };

  const currPath = useMemo(() => {
    if (typeof window !== "undefined") return window.location.href;
  }, []);

  const content = useMemo(() => {
    if (typeof userData?.place === "number") {
      if (userData?.place <= 100) {
        return `Я занимаю ${userData.place} место в топе${
          appliedFiltersCount > 0 ? " по выбранным фильтрам" : ""
        }`;
      }
    }
    return "Топ 100 доноров";
  }, [userData, appliedFiltersCount]);

  return (
    <div className={styles.TopDonorsMobileShare}>
      <Modal
        open={topDonorPageStore.shareModalOpen}
        className={styles.TopDonorsMobileShare_Modal}
        onClose={onCloseModalClick}
      >
        <Modal.Header className={styles.TopDonorsMobileShare_Modal_Header}>
          <div className={styles.TopDonorsMobileShare_Modal_Header_Content}>
            <div
              className={styles.TopDonorsMobileShare_Modal_Header_Content_Title}
            >
              Поделиться
            </div>
            <div
              onClick={onCloseModalClick}
              className={styles.TopDonorsMobileShare_Modal_Header_Content_Close}
            >
              <img src="/static/images/icons/close.svg" alt="close" />
            </div>
          </div>
        </Modal.Header>
        <Modal.Content className={styles.TopDonorsMobileShare_Modal_Content}>
          <div className={styles.TopDonorsMobileShare_Modal_Content_Content}>
            {SHARE_LINKS.map((item) =>
              item.bigComponent(currPath, content, `key_${item.key}`)
            )}
          </div>
        </Modal.Content>
      </Modal>
    </div>
  );
});

export default TopDonorsMobileShareModal;
